import React from 'react';
import '../EmptyTodos/Titulo-EmptyTodos.css'

function TodosError() {
  return <p className='Titulo-EmptyTodos'>Desespérate, hubo un error...</p>;
}

export { TodosError };
